import {
  confirmResetPassword,
  fetchUserAttributes,
  getCurrentUser,
  resetPassword,
} from "aws-amplify/auth";

export const getCurrentUserInfo = async () => {
  const [{ username, userId }, attributes] = await Promise.all([
    getCurrentUser(),
    fetchUserAttributes(),
  ]);

  return { id: userId, username, attributes };
};

export const requestPasswordReset = (username: string) =>
  resetPassword({ username });

export const submitPasswordReset = (
  username: string,
  confirmationCode: string,
  newPassword: string
) => confirmResetPassword({ username, confirmationCode, newPassword });
